import { State } from '../default';

export interface ImpersonationTarget {
  wwid: number;
  name: string;
  email: string;
  role: string;
}

export interface ImpersonationAdmin {
  wwid: number;
  name: string;
}

export interface ImpersonationState extends State {
  isImpersonating: boolean;
  target: ImpersonationTarget | null;
  admin: ImpersonationAdmin | null;
}

export const initialState: ImpersonationState = {
  // `pending` starts true so consumers can wait for the first /current fetch
  // before assuming "not impersonating".
  pending: true,
  error: false,
  fullfilled: false,
  isImpersonating: false,
  target: null,
  admin: null,
};
